import { render, staticRenderFns } from "./TaskModuleRulesRuleDisabled.vue?vue&type=template&id=2ca708a0&scoped=true"
import script from "./TaskModuleRulesRuleDisabled.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesRuleDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca708a0",
  null
  
)

export default component.exports